export const initSavedSearchList = () => {
  const savedSearchList = document.getElementById("saved-search-list") as HTMLUListElement | null;

  if (!savedSearchList) {
    return;
  }

  savedSearchList
    .querySelectorAll<HTMLButtonElement>(".delete-saved-search-item")
    .forEach((deleteButton) => {
      deleteButton.addEventListener(
        "click",
        () => {
          handleDelete(deleteButton);
        },
        { passive: true },
      );
    });
};

const handleDelete = (deleteButton: HTMLButtonElement) => {
  const deleteAlert = document.querySelector(".saved-search-delete-alert") as HTMLDivElement | null;
  const id = deleteButton.dataset.id as string;

  deleteButton.classList.add("d-none");

  const closestListItem = deleteButton.closest("li") as HTMLLIElement;
  const spinner = closestListItem.querySelector(".spinner") as HTMLSpanElement;

  spinner.classList.remove("d-none");

  const presignedToken = new URLSearchParams(window.location.search).get("presigned_token");
  const deleteUrl = presignedToken
    ? `/website-api/saved-search/${id}/?presigned_token=${encodeURIComponent(presignedToken)}`
    : `/website-api/saved-search/${id}/`;

  fetch(deleteUrl, {
    credentials: "same-origin",
    method: "delete",
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.metadata.code !== 200) {
        return;
      }

      closestListItem.remove();

      if (deleteAlert) {
        deleteAlert.style.display = "block";

        setTimeout(() => {
          deleteAlert.style.display = "none";
        }, 4000);
      }
    });
};
